import { jsx as _jsx } from "react/jsx-runtime";
import { LabelsItem } from "@bluframe/mightychroma-mightytool-ui";
const Item = (props) => _jsx(LabelsItem, { ...props });
export default Item;
